// ============================================================================
// VERROUILLAGE DES QUANTITÉS PANIER - VERSION OPTIMISÉE POUR VOTRE THÈME
// ============================================================================

console.log('%c🔒 Script de verrouillage Panier (Structure Détectée) chargé', 'color: #D32F2F; font-weight: bold;');

class CartQuantityLock {
  constructor() {
    this.init();
  }

  init() {
    // On observe les changements du panier (si mise à jour AJAX sans rechargement)
    const observer = new MutationObserver(() => this.lockItems());
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Premier passage immédiat
    this.lockItems();
  }

  // Vérifie si le texte correspond à vos paliers de prix
  isTieredVariant(text) {
    const regex1 = /^(\d+)\s*à\s*(\d+)g\s*=\s*(\d+(?:[,.]\d+)?)€\/g$/i;
    const regex2 = /^(\d+)g\s*et\s*\+\s*=\s*(\d+(?:[,.]\d+)?)€\/g$/i;
    const cleanText = text.trim();
    return regex1.test(cleanText) || regex2.test(cleanText);
  }

  lockItems() {
    // 1. On cible toutes les lignes du panier
    const items = document.querySelectorAll('.cart-item');

    items.forEach(item => {
      // 2. On cherche la valeur de l'option (ex: "12 à 24g = 4€/g")
      const optionValue = item.querySelector('.cart-item__option-value');
      
      if (optionValue && this.isTieredVariant(optionValue.textContent)) {
        this.applyStrictLock(item);
      }
    });
  }

  applyStrictLock(item) {
    // 3. Verrouiller TOUS les inputs de quantité dans cette ligne
    const qtyInputs = item.querySelectorAll('input[name="updates[]"]');
    qtyInputs.forEach(input => {
      if (!input.readOnly) {
        input.readOnly = true;
        input.style.pointerEvents = "none";
        input.style.background = "#f4f4f4";
        input.style.opacity = "0.7";
      }
    });

    // 4. Masquer TOUS les boutons plus/moins dans cette ligne
    const qtyButtons = item.querySelectorAll('.quantity__button, button[name="plus"], button[name="minus"]');
    qtyButtons.forEach(btn => {
      btn.style.visibility = 'hidden'; // On utilise visibility pour ne pas casser le layout
      btn.style.pointerEvents = 'none';
    });

    // 5. Empêcher tout clic sur le wrapper de quantité
    const wrappers = item.querySelectorAll('.cart-quantity, quantity-input');
    wrappers.forEach(w => {
        w.style.pointerEvents = 'none';
        w.style.opacity = '0.8';
    });

    // 6. Ajouter un message d'info si absent
    if (!item.querySelector('.lock-notice-cart')) {
      const notice = document.createElement('div');
      notice.className = 'lock-notice-cart';
      notice.textContent = 'Quantité fixée par le palier choisi';
      notice.style.cssText = 'color: #0F4131; font-size: 11px; font-weight: bold; margin-top: 8px; text-transform: uppercase;';
      
      const infoSection = item.querySelector('.cart-item__product--info') || item;
      infoSection.appendChild(notice);
    }
  }
}

// Lancement au chargement
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CartQuantityLock());
} else {
  new CartQuantityLock();
}